module.exports = __webpack_public_path__ + "img/soster2.91f21f55.png";